import React from "react";
import { withRouter } from "react-router-dom";
import { createPortal } from "react-dom";
import { connect } from "react-redux";
import HelpChatPanel from "../components/HelpChatPanel";
import { SUPPORT_PHONE_NUMBER } from "../constants/support";

const CHAT_URL = "https://tawk.to/chat/5e39c317a89cda5a18841f2d/1j48pl8n0";

class HelpHeader extends React.Component {
  state = { confirmOpen: false, isOpening: false, chatOpen: false };

  openConfirm = () => {
    this.setState({ confirmOpen: true, isOpening: false }, () => {
      // optional: focus primary action for a11y
      const btn = document.getElementById("header-confirm-open-btn");
      btn && btn.focus();
    });
  };

  closeConfirm = () => this.setState({ confirmOpen: false, isOpening: false });

  openChat = () => {
    this.setState({ chatOpen: true, confirmOpen: false });
  };

  closeChat = () => this.setState({ chatOpen: false });

  // Guarded: never call twice for the same click
  openExternal = (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    if (this.state.isOpening) return;

    this.setState({ isOpening: true }, () => {
      const win = window.open(CHAT_URL, "_blank", "noopener,noreferrer");
      if (win) {
        // Success → close the modal, keep SPA visible
        this.setState({ confirmOpen: false, isOpening: false });
      } else {
        // Popup blocked → keep modal open so user can choose in-place
        this.setState({ isOpening: false });
      }
    });
  };

  openInPlace = () => {
    if (this.state.isOpening) return;
    this.setState({ isOpening: true, confirmOpen: false }, () => {
      window.location.assign(CHAT_URL);
    });
  };

  onBackdropClick = (e) => {
    if (e.target === e.currentTarget) this.closeConfirm();
  };

  onKeyDown = (e) => {
    if (!this.state.confirmOpen) return;
    if (e.key === "Escape") this.closeConfirm();
    if (e.key === "Enter") this.openExternal();
  };

  render() {
    const defaultStyle = { display: "inline-flex", position: "absolute", right: 0, top: "50%" };
    const containerStyle = { ...defaultStyle, ...(this.props.containerStyle || {}) };

    return (
      <div className="chat-button" style={containerStyle}>
        {/* Help / Chat icon in header */}
        <button
          type="button"
          className="border-0 bg-transparent"
          aria-haspopup="dialog"
          aria-controls="header-support-chat"
          onClick={this.openChat}
          title="Open customer support"
        >
          <span style={{ alignContent: "center", justifyContent: "center", width: 40, height: 40, borderRadius: "50%", fontSize: 18 }}>
            <img src="/images/chat.svg" alt="Open support" style={{ maxHeight: 40 }} />
          </span>
        </button>

        {/* Confirm modal (legacy Tawk flow) */}
        {/* {this.state.confirmOpen &&
          createPortal(
            <div
              id="header-support-confirm"
              role="dialog"
              aria-modal="true"
              aria-label="Open customer support"
              tabIndex={-1}
              onKeyDown={this.onKeyDown}
              style={modalBackdrop}
              onClick={this.onBackdropClick}
            >
              <div style={modalCard} onClick={(e) => e.stopPropagation()}>
                <div style={modalHeader}>
                  <strong>Open Customer Support?</strong>
                </div>

                <div style={modalBody}>
                  To continue to our customer support portal, you’ll be redirected to open the page in your preferred browser.
                </div>

                <div style={modalActions}>
                  <button className="cancel-button-compact btn" onClick={this.closeConfirm}>
                    Cancel
                  </button>
                  <button
                    id="header-confirm-open-btn"
                    type="button"
                    onClick={this.openExternal}
                    disabled={this.state.isOpening}
                    className="action-button-compact btn"
                  >
                    {this.state.isOpening ? "Opening…" : "Open in New Page"}
                  </button>
                </div>
              </div>
            </div>,
            document.body
          )} */}

        {/* RAG chat modal */}
        {this.state.chatOpen &&
          createPortal(
            <div
              id="header-support-chat"
              role="dialog"
              aria-modal="true"
              aria-label="Support chat"
              tabIndex={-1}
              style={modalBackdrop}
              onClick={this.onBackdropClick}
            >
              <div style={modalCard} onClick={(e) => e.stopPropagation()}>
                <div style={modalHeader}>
                  <strong>Support</strong>
                  <button type="button" onClick={this.closeChat} style={xBtn} aria-label="Close">×</button>
                </div>
                <div style={modalBody}>
                  <HelpChatPanel
                    accessToken={this.props.token}
                    handoffUrl={CHAT_URL}
                    phoneNumber={SUPPORT_PHONE_NUMBER}
                    title="Support chat"
                  />
                </div>
              </div>
            </div>,
            document.body
          )}
      </div>
    );
  }
}

const modalBackdrop = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.35)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 2147483647,
  WebkitTapHighlightColor: "transparent",
  pointerEvents: "auto",
};

const modalCard = {
  width: "min(92vw, 620px)",
  background: "#fff",
  borderRadius: 12,
  border: "1px solid #eef2f7",
  boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
  overflow: "hidden",
  fontFamily: "system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif",
};

const modalHeader = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "12px 14px",
  borderBottom: "1px solid #eee",
};

const xBtn = {
  border: "none",
  background: "transparent",
  fontSize: 20,
  cursor: "pointer",
  lineHeight: 1,
};

const modalBody = {
  padding: "14px",
  fontSize: 14,
  lineHeight: 1.5,
};

const modalActions = {
  display: "flex",
  gap: 8,
  justifyContent: "flex-end",
  padding: "12px 14px 16px",
  flexWrap: "wrap",
};

const baseBtn = {
  padding: "10px 14px",
  borderRadius: 8,
  fontSize: 14,
  cursor: "pointer",
};

const primaryBtn = {
  ...baseBtn,
  border: "1px solid #4C6EF8",
  background: "#4C6EF8",
  color: "#fff",
};

const secondaryBtn = {
  ...baseBtn,
  border: "1px solid #87A6EA",
  background: "white",
  color: "#87A6EA",
};

const mapStateToProps = (state) => ({
  token: state.token,
});

// export default withRouter(HelpHeader);
export default connect(mapStateToProps)(withRouter(HelpHeader));
